module.exports = {"private":true,"main":"./SelectInput.js"}


//////////////////
// WEBPACK FOOTER
// ./app/javascript/components/fields/SelectInput/package.json
// module id = 836
// module chunks = 0 1